export default __webpack_public_path__ + "static/media/EM0200.34I-19952_-23281_0.8fff39b1.jpg";